export function customColumnSort(a, b, columnName) {
    const priceA = a.original[columnName] ? parseFloat(a.original[columnName].replace(/[$,%]/g, '')) : 0;
    const priceB = b.original[columnName] ? parseFloat(b.original[columnName].replace(/[$,%]/g, '')) : 0;
    
    return priceA - priceB;
}

